import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const getMultipartHeaders = () => ({
  "Content-Type": "multipart/form-data",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
});

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const getAffiliationsList = async () => {
  return await axiosInstance.get("affiliations/getlist", { headers });
};

export const getAffiliationById = async (id) => {
  const response = await axiosInstance.get(`affiliations/get/${id}`, { headers });
  return response.data.result;
};

export const addAffiliation = async (formData) => {
  return await axiosInstance.post("affiliations/add", formData, {
    headers: getMultipartHeaders(),
  });
};

export const updateAffiliation = async (formData) => {
  return await axiosInstance.put("affiliations/update", formData, {
    headers: getMultipartHeaders(),
  });
};

export const deleteAffiliation = async (id) => {
  return await axiosInstance.delete(`affiliations/delete/${id}`, { headers });
};
